<template>
  <div class="rb-step-indicator">
    <div class="rb-step-bar" :style="width"></div>
  </div>
</template>
<script>
/**
 * Progress bar for current step
 *
 * @props
 * currentStep: Number
 * totalSteps: Number
 */
export default {
  props: {
    currentStep: {
      type: Number,
      default: 1,
    },
    totalSteps: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    width: function () {
      return `width: ${(this.currentStep + 1) * (100 / this.totalSteps)}%`;
    },
  },
};
</script>
